import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();

const appInsights = new ApplicationInsights({
  config: {
    connectionString: import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING || '',
    extensions: [reactPlugin as any], // eslint-disable-line @typescript-eslint/no-explicit-any
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory }
    },
    enableAutoRouteTracking: true,
    disableFetchTracking: false,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    disableAjaxTracking: false,
    autoTrackPageVisitTime: true,
    enableUnhandledPromiseRejectionTracking: true,
    disableExceptionTracking: false,
    loggingLevelConsole: 0,
    loggingLevelTelemetry: 2,
    // Disable cookies by default until consent is given
    disableCookiesUsage: true
  }
});

if (import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING) {
  appInsights.loadAppInsights();
  // Don't track page view automatically - wait for consent
}

export { reactPlugin, appInsights, browserHistory };